import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { IQuestionModel } from '@care-portals/api-interfaces';
import { QuestionsCatalog } from '@care-portals/data';
import { CommonFacade } from '../../../+store/common/common.facade';

@Component({
  selector: 'my-health-admin-form-engine',
  templateUrl: './form-engine.component.html',
  styleUrls: ['./form-engine.component.less'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class FormEngineComponent implements OnInit {
  @Input() questions: any[];
  @Input() data: any;
  @Input() brand: string;
  @Input() customerId: string;
  selectedQuestions: IQuestionModel[] = [];
  editMode = true;

  constructor(private commonFacade: CommonFacade) {}

  ngOnChanges(changes: SimpleChanges): void {}

  ngOnInit(): void {
    this.commonFacade.editMode$.subscribe(
      editMode => (this.editMode = editMode)
    );

    this.questions.map(field => {
      const question = QuestionsCatalog.find(qModel => {
        if (qModel.type === 'image_list') {
          return false;
        }

        return qModel.field === field;
      });

      if (question) {
        this.selectedQuestions = [...this.selectedQuestions, question];

        const key = question.field;
        if (this.data[key] === undefined) {
          this.data[key] = {};
          if (question.type === 'polar_check') {
            this.data[key].isNo = true;
          }
        }
      }
    });
  }
}
